// Reference texts for the "Vorgaben" panel (run screen, instructor only). The wording is
// copied from the procedure documents, so it is kept as plain data rather than composed.

export type Guideline = {
  id: string;
  title: string;
  meta: string;
  text: string;
};

const META = 'Bereich 212 · Stand 21.09.2026 · Version 1.0';

export const GUIDELINES: Guideline[] = [
  {
    id: 'einsatz',
    title: 'VA Einsatz der Einsatzleitung Rettungsdienst',
    meta: META,
    text: `Einsatzgründe EL-RD:
- mehr als 4 Verletzte
- Einsatzlagen mit erhöhtem Koordinierungsbedarf
- explizite Nachforderung durch Kräfte

Als Einsatzstellen mit erhöhtem Koordinierungsbedarf gelten z. B.: Personensuche; Großbrände mit Menschenleben in Gefahr; Verkehrsunfälle mit 3 oder mehr beteiligten Fahrzeugen; Brandeinsätze und Technische Hilfeleistung mit Menschenleben in Gefahr ab Stufe 3 oder bei erwartbarer erhöhter Patientenzahl.

Entscheidung: Katastrophenlage? Ja → kombinierte Alarmierung OrgL + LNA. Nein → ≥ 3 NAs im Einsatz? Ja → OrgL + LNA. Nein → ≥ 10 Verletzte? Ja → OrgL + LNA. Nein → Alarmierung OrgL.

Bei alleiniger Alarmierung des OrgL: Der 1. NA vor Ort übernimmt die Aufgaben des LNA. Bei Veränderung der Lage unter den gegebenen Kriterien ist eine Nachalarmierung des LNA jederzeit möglich.`,
  },
  {
    id: 'kommissarisch',
    title: 'VA Kommissarische Einsatzleitung Rettungsdienst',
    meta: META,
    text: `Alarmierung durch ILS: Einsatz mit ≥ 5 Patienten oder bereits alarmierte EL-RD.

1. Rettungsmittel vor Ort: KEINE Individualversorgung. Übernahme Vorsichtung & Koordination nachrückender Kräfte; bedarfsgerechte Einrichtung Rettungsmittelhalteplatz. Übergabe ESt an OrgL.

1. NA vor Ort: LNA alarmiert? Nein → Übernahme Aufgaben LNA durch 1. NA. Ja → Unterstützung bei Patientenversorgung.

Beide münden in: Bildung EL-RD durch OrgL + LNA.`,
  },
  {
    id: 'alarmierung',
    title: 'VA Alarmierung der Einsatzleitung Rettungsdienst',
    meta: META,
    text: `Alarmierung: Melderalarm OrgL/LNA Gesamt.
Meldung OrgL: telefonische Rückmeldung durch OrgL bei der ILS. Bei Bedarf: Meldung LNA, telefonische Rückmeldung durch LNA bei der ILS.
Zuteilung zum Einsatz. Dann entweder: OrgL besetzt Fahrzeug (optional: LNA besetzt Fahrzeug) oder: OrgL und LNA besetzen gemeinsam ein Fahrzeug.
Anfahrt: Anfahrt der Einsatzstelle; Übernahme der Lage.`,
  },
  {
    id: 'sichtung',
    title: 'VA Sichtung von Patienten bei MANV/MANE-Lagen',
    meta: META,
    text: `Vorsichtung, Ablauf:
1. Patient gehfähig? Ja: Kategorie III.
2. Tödliche Verletzung? Ja: Kategorie V, nach Befundbestätigung durch einen Arzt.
3. (A) Spontanatmung vorhanden? Nein: Spontanatmung nach Freimachen der Atemwege? Ja: Kategorie I. Nein: Kategorie V, nach Befundbestätigung durch einen Arzt.
4. (B) Atemfrequenz über 30/min? Ja: Kategorie I.
5. (C) Spritzende Blutung? Ja: Blutstillung; die Antwort ändert die Kategorie nicht.
6. Fehlender Radialispuls? Ja: Kategorie I.
7. (D) Befolgt einfache Befehle? Nein: Kategorie I. Ja: Kategorie II.

Sonderfall limitierte Ressourcen: Bei limitierten Ressourcen (Katastrophenfall) kommt vor der Einordnung nach I oder II die Frage nach der Überlebenschance. Nein: Kategorie IV, betreuende Behandlung. Ja: normaler Ablauf nach I oder II.

Zweite Stufe, nach der Einordnung:
- Kategorie I: Notfallmaßnahmen nach Befund, danach Sichtung durch den LNA mit Entscheidung über die akute OP-Indikation. Ohne Indikation Rückstufung nach II. Mit Indikation Transportfreigabe durch LNA oder OrgL: erteilt heißt sofortiger Transport, nicht erteilt heißt Schwerstverletzten-Behandlungsplatz.
- Kategorie II: Schwerstverletzten-Behandlungsplatz, Sichtung durch den Triagearzt, Transport nach Dringlichkeit.
- Kategorie III: Leichtverletzten-Behandlungsplatz mit Vitalparametern und erneuter Untersuchung. Ein kritischer Befund verlegt auf den Schwerstverletzten-Behandlungsplatz, sonst Transport nach Verfügbarkeit.
- Kategorie IV und V: kein zweiter Abschnitt, nur das Verlegungsziel.

Checkliste Notfallmaßnahmen: Freimachen der Atemwege; Notfallintubation ggf. Notkoniotomie; Thoraxdekompression bei Spannungspneumothorax; Maskenbeatmung; Blutstillung; Dringliche Intubation bei GCS < 10, Blutung im Mund-Rachen-Raum, Aspiration.`,
  },
];
